import { render, staticRenderFns } from "./MidTab.vue?vue&type=template&id=45050f18"
import script from "./MidTab.vue?vue&type=script&lang=js"
export * from "./MidTab.vue?vue&type=script&lang=js"
import style0 from "./MidTab.vue?vue&type=style&index=0&id=45050f18&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports